<template>

  
  <nav class="navbar" :class="{ 'navbar-scrolled': isScrolled }">

  <!-- Contact Bar -->
  <div class="contact-bar">
    <div class="container">
      <div class="contact-bar-content">
        <div class="contact-info">
          <a href="tel:03225150405" class="contact-link">
            <svg class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
            0322 515 04 05
          </a>
          <a href="tel:05526833403" class="contact-link">
            <svg class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
            0552 683 34 03
          </a>
        </div>
        <div class="contact-address">
          <a href="https://www.google.com/maps?q=37.461503125207315,35.82148209864696" target="_blank" class="contact-link address-link">
            <svg class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            Modern Kurs Merkezi
          </a>
        </div>
      </div>
    </div>
  </div>

    <div class="container">
      <div class="navbar-content">
        <!-- Logo -->
        <div class="navbar-logo">
          <router-link to="/" class="logo-link">
            <img src="@/assets/images/logo.png" alt="Modern Kurs Logo" class="logo-image" />
          </router-link>
        </div>
        
        <!-- Desktop Navigation Buttons (1530px+) -->
        <div class="desktop-nav-buttons">
          <router-link to="/" class="desktop-nav-btn">
            <svg class="nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
            Ana Sayfa
          </router-link>
          
          <router-link to="/about" class="desktop-nav-btn">
            <svg class="nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            Hakkımızda
          </router-link>
          
          <router-link to="/contact" class="desktop-nav-btn">
            <svg class="nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
            </svg>
            İletişim
          </router-link>
          
          <router-link to="/blogs" class="desktop-nav-btn">
            <svg class="nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
            </svg>
            Blog
          </router-link>
          
          <router-link to="/login" class="desktop-nav-btn desktop-nav-btn-cta">
            <svg class="nav-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
            </svg>
            Modern Randevu
          </router-link>
        </div>
        
        <!-- Mobile Dropdown Menu (1530px-) -->
        <div class="dropdown-menu-container">
          <button class="dropdown-toggle" @click="toggleDropdown" :class="{ 'is-open': isDropdownOpen }">
            <svg class="menu-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
            </svg>
            <span class="menu-text">Menü</span>
            <svg class="dropdown-arrow" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </button>
          
          <div class="dropdown-menu" :class="{ 'dropdown-menu-open': isDropdownOpen }">
            <router-link to="/" class="dropdown-item" @click="closeDropdown">
              <svg class="dropdown-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
              </svg>
              Ana Sayfa
            </router-link>
            
            <router-link to="/about" class="dropdown-item" @click="closeDropdown">
              <svg class="dropdown-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              Hakkımızda
            </router-link>
            
            <router-link to="/contact" class="dropdown-item" @click="closeDropdown">
              <svg class="dropdown-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              İletişim
            </router-link>
            
            <router-link to="/blogs" class="dropdown-item" @click="closeDropdown">
              <svg class="dropdown-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
              </svg>
              Blog
            </router-link>
            
            <div class="dropdown-divider"></div>
            
            <router-link to="/login" class="dropdown-item dropdown-item-cta" @click="closeDropdown">
              <svg class="dropdown-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
              </svg>
              Modern Randevu
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'CorporateNavbar',
  setup() {
    // Navbar state
    const isScrolled = ref(false)
    const isDropdownOpen = ref(false)
    
    // Navbar functions
    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50
    }
    
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value
    }
    
    const closeDropdown = () => {
      isDropdownOpen.value = false
    }
    
    const scrollToTop = () => {
      // Sayfa en üstüne git
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    
    onMounted(() => {
      // Add scroll listener
      window.addEventListener('scroll', handleScroll)
    })
    
    onUnmounted(() => {
      // Remove scroll listener
      window.removeEventListener('scroll', handleScroll)
    })
    
    return {
      isScrolled,
      isDropdownOpen,
      toggleDropdown,
      closeDropdown,
      scrollToTop
    }
  }
}
</script>

<style scoped>
/* Contact Bar */
.contact-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 0.3rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.contact-bar-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
}

.contact-info {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.contact-address {
  text-align: center;
}

.contact-link {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  padding: 0.2rem 0.4rem;
  border-radius: 6px;
}

.contact-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #667eea;
  transform: translateY(-1px);
}

.contact-link:hover .contact-icon {
  transform: scale(1.1);
  color: #667eea;
}

.contact-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.address-link {
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Navigation Bar */
.navbar {
  margin-top: -15px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.navbar-scrolled {
  background: #ffffff;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem 2rem;
  max-width: 100%;
  margin: 0;
}

/* Logo */
.navbar-logo {
  flex-shrink: 0;
  margin-left: 0;
  padding-left: 0;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #2c3e50;
  justify-content: flex-start;
  margin-left: 0;
  padding-left: 0;
}

.logo-image {
  width: 300px;
  height: 100px;
  border-radius: 8px;
  margin-left: 0;
  padding-left: 0;
  margin-top: 10px;
}

/* Desktop Navigation Buttons (1530px+) */
.desktop-nav-buttons {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  z-index: 1002;
}

.desktop-nav-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: #575757;
  font-weight: 500;
  font-size: 1.1rem;
  padding: 0.8rem 1.2rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.desktop-nav-btn:hover {
  color: #008FC5;
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.desktop-nav-btn-cta {
  background: linear-gradient(135deg, #008FC5 0%, #0077a3 100%);
  color: white !important;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(0, 140, 197, 0.3);
}

.desktop-nav-btn-cta:hover {
  background: linear-gradient(135deg, #0077a3 0%, #005a7a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 140, 197, 0.4);
}

.nav-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

/* Mobile Dropdown Menu (1530px-) */
.dropdown-menu-container {
  display: none;
  position: relative;
  z-index: 1002;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #008FC5 0%, #0077a3 100%);
  color: white;
  border: none;
  padding: 0.8rem 1.2rem;
  border-radius: 12px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 140, 197, 0.3);
}

.dropdown-toggle:hover {
  background: linear-gradient(135deg, #0077a3 0%, #005a7a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 140, 197, 0.4);
}

.dropdown-toggle.is-open {
  background: linear-gradient(135deg, #0077a3 0%, #005a7a 100%);
  box-shadow: 0 8px 25px rgba(0, 140, 197, 0.4);
}

.menu-icon {
  width: 20px;
  height: 20px;
  transition: all 0.3s ease;
}

.menu-text {
  font-weight: 600;
}

.dropdown-arrow {
  width: 18px;
  height: 18px;
  transition: all 0.3s ease;
}

.dropdown-toggle.is-open .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-width: 280px;
  padding: 1rem 0;
  margin-top: 0.5rem;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-menu-open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.5rem;
  text-decoration: none;
  color: #575757;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  border-radius: 0;
}

.dropdown-item:hover {
  background: rgba(0, 143, 197, 0.05);
  color: #008FC5;
  transform: translateX(5px);
}

.dropdown-item-cta {
  background: linear-gradient(135deg, #008FC5 0%, #0077a3 100%);
  color: white !important;
  margin: 0.5rem 1rem;
  border-radius: 12px;
  font-weight: 600;
}

.dropdown-item-cta:hover {
  background: linear-gradient(135deg, #0077a3 0%, #005a7a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 140, 197, 0.3);
}

.dropdown-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.dropdown-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0.5rem 0;
}

/* Action Buttons */
.navbar-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-shrink: 0;
}

.btn-sm {
  padding: 0.6rem 1.2rem;
  font-size: 0.9rem;
  background: #008FC5;
  color: #fff;
  border-radius: 5px;
  font-weight: 600;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  border: none;
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.8rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
}

.mobile-menu-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.hamburger-icon {
  width: 24px;
  height: 24px;
  color: #2c3e50;
  transition: all 0.3s ease;
}

.mobile-menu-toggle.is-open .hamburger-icon {
  transform: rotate(90deg);
  color: #667eea;
}

/* Container */
.container {
  max-width: 100%;
  margin: 0;
  padding: 0;
}



@media (max-width: 1200px) {
  .container {
    max-width: 100%;
    padding: 0 1rem;
  }
  
  .navbar-content {
    padding: 0.5rem 1rem;
  }
  
  .logo-image {
    width: 220px;
    height: 70px;
  }
  
  .contact-bar {
    padding: 0.3rem 0;
  }
  
  .contact-info {
    gap: 1rem;
  }
  
  .contact-link {
    font-size: 0.7rem;
  }
  
  /* Contact Bar Mobile */
  .contact-bar-content {
    flex-direction: column;
    gap: 0.3rem;
    text-align: center;
  }
  
  .contact-info {
    justify-content: center;
    gap: 0.8rem;
  }
  
  .contact-address {
    text-align: center;
  }
  
  .address-link {
    max-width: 100%;
    white-space: normal;
    text-align: center;
  }
  
  /* Navbar Mobile */
  .navbar {
    margin-top: 13px!important;
  }
  
  /* Desktop Buttons Hide, Dropdown Show */
  .desktop-nav-buttons {
    display: none;
  }
  
  .dropdown-menu-container {
    display: block;
  }
  
  /* Dropdown Menu Mobile */
  .dropdown-toggle {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
  
  .menu-text {
    display: none;
  }
  
  .dropdown-menu {
    min-width: 250px;
    right: -0.5rem;
  }
  
  .dropdown-item {
    padding: 0.8rem 1.2rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 1024px) {
  .container {
    max-width: 100%;
    padding: 0 1.5rem;
  }
  
  .navbar-content {
    padding: 0.7rem 1.5rem;
  }
  
  .logo-image {
    width: 250px;
    height: 80px;
  }
  
  .contact-bar {
    padding: 0.4rem 0;
  }
  
  .contact-link {
    font-size: 0.8rem;
  }
  
  /* Contact Bar Mobile */
  .contact-bar-content {
    flex-direction: column;
    gap: 0.3rem;
    text-align: center;
  }
  
  .contact-info {
    justify-content: center;
    gap: 0.8rem;
  }
  
  .contact-address {
    text-align: center;
  }
  
  /* Dropdown Menu */
  .dropdown-toggle {
    padding: 0.7rem 1rem;
    font-size: 0.9rem;
  }
  
  .dropdown-menu {
    min-width: 240px;
  }
}
  
  .address-link {
    max-width: 100%;
    white-space: normal;
    text-align: center;
  }
  
  /* Navbar Mobile */
  .navbar {
    top: 50px!important;
  }
  



@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 0 1rem;
  }
  
  .navbar-content {
    padding: 0.5rem 1rem;
  }
  
  .logo-image {
    width: 220px;
    height: 70px;
  }
  
  .contact-bar {
    padding: 0.3rem 0;
  }
  
  .contact-info {
    gap: 1rem;
  }
  
  .contact-link {
    font-size: 0.7rem;
  }
  
  /* Contact Bar Mobile */
  .contact-bar-content {
    flex-direction: column;
    gap: 0.3rem;
    text-align: center;
  }
  
  .contact-info {
    justify-content: center;
    gap: 0.8rem;
  }
  
  .contact-address {
    text-align: center;
  }
  
  .address-link {
    max-width: 100%;
    white-space: normal;
    text-align: center;
  }
  
  /* Navbar Mobile */
  .navbar {
    top: 50px!important;
  }
  
  /* Dropdown Menu Mobile */
  .dropdown-toggle {
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
  }
  
  .menu-text {
    display: none;
  }
  
  .dropdown-menu {
    min-width: 220px;
    right: -1rem;
  }
  
  .dropdown-item {
    padding: 0.7rem 1rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 600px) {
  .dropdown-toggle {
    padding: 0.4rem 0.7rem;
    font-size: 0.75rem;
  }
  
  .dropdown-menu {
    min-width: 200px;
    right: -1.5rem;
  }
  
  .dropdown-item {
    padding: 0.6rem 0.8rem;
    font-size: 0.8rem;
  }
  
  .logo-image {
    width: 180px;
    height: 60px;
  }
}

@media (max-width: 480px) {
  .dropdown-toggle {
    padding: 0.3rem 0.6rem;
    font-size: 0.7rem;
  }
  
  .dropdown-menu {
    min-width: 180px;
    right: -2rem;
  }
  
  .dropdown-item {
    padding: 0.5rem 0.7rem;
    font-size: 0.75rem;
  }
  
  .logo-image {
    width: 160px;
    height: 55px;
  }
  .navbar {
    z-index: 1000;
    margin-top: 0rem!important;
  }
}

@media (max-width: 400px) {
  .contact-bar {
    z-index: 999;
    padding: 0.5rem 0;
  }
  
  .contact-bar-content {
    flex-direction: column;
    gap: 0.3rem;
  }
  
  .contact-info {
    gap: 0.5rem;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .contact-link {
    font-size: 0.75rem;
    padding: 0.1rem 0.3rem;
  }
  
  .contact-address {
    text-align: center;
    margin-top: 0.2rem;
  }
  
  .address-link {
    max-width: 100%;
    white-space: normal;
    font-size: 0.75rem;
  }
  
  .navbar {
    z-index: 1000;
    margin-top: 0rem!important;
  }
}

@media (max-width: 394px) {
  .contact-bar {
    padding: 0.4rem 0;
  }
  
  .contact-bar-content {
    gap: 0.2rem;
  }
  
  .contact-info {
    gap: 0.3rem;
  }
  
  .contact-link {
    font-size: 0.7rem;
    padding: 0.05rem 0.2rem;
  }
  
  .contact-address {
    margin-top: 0.1rem;
  }
  
  .address-link {
    font-size: 0.7rem;
  }
  
  .navbar {
    margin-top: -2rem;
  }
}

@media (max-width: 360px) {
  .contact-bar {
    padding: 0.3rem 0;
  }
  
  .contact-info {
    gap: 0.2rem;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 100%;
  }
  
  .contact-link {
    font-size: 0.65rem;
    padding: 0.05rem 0.15rem;
    flex: 0 0 auto;
    min-width: 0;
  }
  
  .address-link {
    font-size: 0.65rem;
  }
  
  .navbar {
    margin-top: -2rem;
  }
}
</style>
